import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })

export const formatCurrency = (value: number) => BRL.format(value)

const PERCENT = new Intl.NumberFormat("pt-BR", { style: "percent", maximumFractionDigits: 0 })

export const formatPercent = (fraction: number) => PERCENT.format(fraction)

// Letras entram: o CNPJ alfanumérico já está valendo e tem a mesma máscara do numérico. Tirar as
// letras aqui mostraria na tela o CNPJ de outra empresa. Sem os 14 caracteres, formata o que der
// — a raiz sozinha ainda é reconhecível —, e nunca inventa dígito.
export const formatCnpj = (value: string): string => {
    const cnpj = value.toUpperCase().replace(/[^A-Z0-9]/g, "")
    if (cnpj.length === 14) {
        return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`
    }
    if (cnpj.length === 8) return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5)}`
    return cnpj
}

// Partículas não são sobrenome: em "Maria dos Santos" quem identifica é "Santos".
const PARTICULAS = new Set(["da", "das", "de", "do", "dos", "e"])

// Primeiro nome e a inicial do último sobrenome. Nome completo num e-mail encaminhado, ao lado do
// valor da parcela e do contrato, identifica a pessoa para quem quer que abra o link — e quem
// precisa reconhecer de quem se trata é o RH, que já tem a lista inteira.
export const maskName = (fullName: string): string => {
    const partes = fullName
        .trim()
        .split(/\s+/)
        .filter((parte) => parte.length > 0)

    const primeiro = partes[0]
    if (!primeiro) return ""

    const sobrenome = [...partes]
        .slice(1)
        .reverse()
        .find((parte) => !PARTICULAS.has(parte.toLowerCase()) && parte.replace(".", "").length > 1)

    return sobrenome ? `${primeiro} ${sobrenome[0]?.toUpperCase()}.` : primeiro
}
